/**
 * author:davy_mll
 * date:2019-5-7
 * 处理表头拼接
 * keys 是处理数据的key 默认是：‘key’,'name','list'
 */


import React from 'react';
import { Button, Modal } from 'antd';

export const handleTabelHeader = (headList = [], keys = { key: 'key', name: 'name', list: 'list' }, href) => {
    let data = [];
    if (headList && headList.length > 0) {
        headList.forEach(e => {
            data.push(_handleOuterLayer(e, keys, href))
        });
    }
    return data;
}

let _handleOuterLayer = (e, keys, href) => {
    let data = {
        title: e[keys['name']],
        name: e[keys['key']],
        formItem: {},
    }
    if (e.type) {
        data.formItem['type'] = e.type;
    }
    if (e.width && e.width > 0) {
        data['tableItem'] = {
            width: e.width
        }
    }
    if (e[keys['list']] && e[keys['list']].length > 0) {
        let chlidren = [];
        e[keys['list']].forEach(children => {
            chlidren.push(_handleChildren(children, keys, href));
        });
        data['tableItem']['children'] = chlidren;
    }
    return data;
}

let _handleChildren = (e, keys, href) => {
    let data = {
        dataIndex: e[keys['key']],
        key: e[keys['key']],
        title: e[keys['name']],
        width: e.width ? e.width : 60
    }
    if (data['key'].indexOf('_remark') !== -1) {
        data['render'] = (e) => {
            if (e && e !== '') {
                let change = (e) => {
                    href.setState({ [data['key']]: e })
                }
                return [
                    <Button
                        type='link'
                        onClick={() => {
                            change(true)
                        }}>
                        点击查看
                    </Button>,
                    <Modal
                        key={data['key']}
                        title='评语'
                        visible={href.state[data['key']]}
                        footer={<Button onClick={() => change(false)}>关闭</Button>}
                        onCancel={() => change(false)}
                    >
                        {e}
                    </Modal>
                ]
            }
            return null
        }
    }
    if (e[keys['list']] && e[keys['list']].length > 0) {
        let chlidren = [];
        e[keys['list']].forEach(_e => {
            chlidren.push(_handleChildren(_e, keys));
        });
        data['children'] = chlidren;
    }
    return data;
}


export const handleExportHeader = (headList = [], keys = { key: 'key', name: 'name', list: 'list' }, children = false) => {
    let data = [];
    if (!children) {
        data.push({
            headerName: '',
            width: 30,
            field: 'rowIndex',
            hidden: true,
            suppressMovable: true,
            cellStyle: {
                textAlign: 'center',
                padding: '5px 0',
                color: '#595959',
                backgroundColor: '#f0f0f0',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: '500',
                boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
            },
        });
    }
    if (headList && headList.length > 0) {
        headList.forEach(e => {
            if (e.type && e.type === 'hidden') {
                return;
            }
            data.push(_handleExportChildren(e, keys))
        });
    }
    return data;
}


let _handleExportChildren = (e, keys) => {
    let data = {
        headerName: e[keys['name']]
    };
    if (e[keys['list']] && e[keys['list']].length > 0) {
        data['children'] = handleExportHeader(e[keys['list']], keys, true);
    } else {
        data['field'] = e[keys['key']];
        data['width'] = e.width;
    }
    return data;
}